export default __webpack_public_path__ + "img/greenCheck.97782abc.svg";